import { useEffect } from "react";
import "./AppHeader.scss";
import { theme, Layout, AutoComplete, Input, Empty } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Register } from "./components";
import AppTitle from "../AppTitle/AppTitle";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPatients } from "../../features/patients/patientsActions";
import { resetPatientsError } from "../../features/patients/patientsSlice";
import useStep1 from "../../hooks/useStep1";
import Utils from "../../utils";

const { Header } = Layout;

export default function AppHeader({ searchVal, setSearchVal }) {
  const { useToken } = theme;
  const { token } = useToken();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const is_searched = location.pathname === "/patients";
  const dispatch = useDispatch();
  const {
    patientsData: { results: patients },
    error,
  } = useSelector((state) => state?.patients);
  const { isAuthenticated } = useSelector((state) => state?.auth);
  const navigate = useNavigate();
  const {
    onSearch,
    setUrlSearchParams,
    is_search_limit_reached,
    isMobile,
    width,
  } = useStep1(searchVal, setSearchVal);

  useEffect(() => {
    if (location.pathname === "/patients") {
      setSearchVal(searchParams?.get("search") || "");
      dispatch(
        getPatients({
          search: searchParams?.get("search"),
          page: searchParams?.get("page") || 1,
          per_page: searchParams?.get("per_page") || 10,
          category: searchParams?.get("category") || undefined,
          own_only: searchParams?.get("own_only") || undefined,
          is_active: true,
        })
      );
    }
  }, [searchParams, dispatch, isAuthenticated, setSearchVal, location.pathname]);

  const onSelect = (_, option) => {
    setSearchVal(option?.label ? option?.label : "");
    setUrlSearchParams({
      search: option?.label ? option?.label : undefined,
      page: 1,
      per_page: 10,
    });
    if (searchVal) {
      onSearch("", true);
    }
  };

  return (
    <Header
      className="appHeader-cont"
      style={
        is_searched && isMobile
          ? {
              height: "90px",
            }
          : null
      }>
      {is_searched ? (
        <div className="appHeader-cont__left">
          <AppTitle
            token={token}
            classNameCont="appHeader-cont__left__titeWrapper"
            classNameTitle="appHeader-cont__title"
            onTitleClick={() => {
              if (error) {
                dispatch(resetPatientsError());
              }
              navigate("/");
            }}
          />
          <AutoComplete
            className="appHeader-cont__left__search"
            disabled={is_search_limit_reached}
            style={{ height: isMobile ? "32px" : "40px" }}
            options={Utils?.madeUnique(patients)?.map((patient) => ({
              label: `${patient?.first_name ? patient?.first_name : ""} ${
                patient?.last_name ? patient?.last_name : ""
              }`,
              value: `${patient?.first_name ? patient?.first_name : ""} ${
                patient?.last_name ? patient?.last_name : ""
              }`,
              key: `${patient?.id}`,
            }))}
            value={searchVal}
            onSearch={onSearch}
            onSelect={onSelect}
            onKeyDown={(e) => {
              const value = e?.target?.value;
              if (
                (e?.key === "Enter" || e?.code === "NumpadEnter") &&
                value &&
                value !== searchVal
              ) {
                setSearchVal(value);
                setUrlSearchParams({
                  search: value ? value : undefined,
                  page: 1,
                  per_page: 10,
                });
              }
            }}
            notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}>
            <Input
              style={{
                borderRadius: "24px",
                height: isMobile ? "32px" : "40px",
              }}
              size={isMobile ? "middle" : "large"}
              placeholder="Search"
              prefix={<SearchOutlined />}
              allowClear
            />
          </AutoComplete>
        </div>
      ) : null}
      <Register
        token={token}
        isMobile={isMobile}
        width={width}
        is_searched={is_searched}
      />
    </Header>
  );
}
